import fileSaver from '../helpers/download.helper'
import { AxiosService } from '../services/axios.service'
import { toastActions } from './toast.actions'
import { exportConstants } from '../constants'
import { Creators as SiteCreators } from '../ducks/site/site'

export const handleExport = (params, url, fileName) => dispatch => {
	const { danger } = toastActions

	dispatch({
		type: exportConstants.EXPORT_DATA
	})
	dispatch(SiteCreators.showLoading())

	AxiosService.get(url, {
		responseType: 'blob',
		params: params
	})
		.then(({ data }) => {
			if (data) {
				dispatch(downloadData(data, fileName))
			} else {
				dispatch(
					danger({
						message: `Erro ao exportar dados: ${error}`
					})
				)
			}
			dispatch(SiteCreators.hideLoading())
		})
		.catch(error => {
			dispatch(SiteCreators.hideLoading())
			dispatch(
				danger({
					message: `Erro ao exportar dados: ${error}`
				})
			)
		})
}

const downloadData = (downloadData, fileName) => async dispatch => {
	dispatch({
		type: exportConstants.DOWNLOAD_DATA
	})

	await fileSaver(downloadData, fileName)
}
